import registerTemplate from "../templates/pages/register.html?raw";
import pageLoadingTemplate from "../templates/pages/pageloading.html?raw";
import { FIELDS } from "../constants/register";
// import { postApi } from "../services/api";
import { cognitoSignUp } from "../services/cognito";
import { saveJsonToLocalStorage } from "../services/localStorage";
import "../styles/register.css";

// const API_URL = import.meta.env.VITE_API_URL as string;

export default class RegisterPage {
  private currentTab = 0;
  private registerForm: HTMLFormElement;
  private steps: HTMLCollectionOf<Element>;
  private fields: { [key: string]: string };
  constructor() {
    this.loadPage();
    this.steps = document.getElementsByClassName("step");
    this.showTab(this.currentTab);
    this.registerForm = document.getElementById("signUpForm") as HTMLFormElement;
    this.fields = {};

    this.registerForm.addEventListener("submit", (event) => {
      console.log("submitting form");
      this.submitForm(event);
    });
  }

  private loadPage(): void {
    document.querySelector<HTMLDivElement>("#app")!.innerHTML = registerTemplate;
  }

  private showTab(tabNumber: number) {
    // This function will display the specified tab of the form...
    (this.steps[tabNumber] as HTMLElement).style.display = "block";
    //... and fix the Previous/Next buttons:
    this.regeneratePrevNextButtons();
    //... and run a function that will display the correct step indicator:
    this.updateStepIndicator(tabNumber);
    this.populateForm();
  }

  private nextPrev(move: number) {
    // This function will figure out which tab to display
    // Exit the function if any field in the current tab is invalid:
    if (move == 1 && !this.validateForm()) {
      console.log("form not valid or trying to move more than 1 step!");
      return false;
    }
    // Store current tab data
    this.storeTabFormData();
    // Hide the current tab:
    (this.steps[this.currentTab] as HTMLElement).style.display = "none";
    // Increase or decrease the current tab by 1:
    this.currentTab = this.currentTab + move;
    // Otherwise, display the correct tab:
    this.showTab(this.currentTab);
  }

  private inputError(input: HTMLInputElement, errorMessage: string) {
    input.classList.add("invalid");
    const errorDiv = document.createElement("div");
    errorDiv.className = "text-red-500 text-xs italic error-message";
    errorDiv.innerHTML = errorMessage;
    input.parentNode!.append(errorDiv);
  }

  private validateForm() {
    // This function deals with validation of the form fields
    let valid = true;
    const currentStepInputs = this.steps[this.currentTab].getElementsByTagName("input");
    let errorMessage = document.createElement("div");
    errorMessage.className = "text-red-500 text-xs italic";

    // Clear previous validation errors
    for (let input = 0; input < currentStepInputs.length; input++) {
      // Remove invalid class
      currentStepInputs[input].classList.remove("invalid");
      // Remove error message divs
      const parentNode = currentStepInputs[input].parentNode;
      const errorDivs = parentNode?.querySelectorAll(".error-message");
      errorDivs?.forEach((div) => div.remove());
    }

    // A loop that checks every input field in the current tab:
    for (let input = 0; input < currentStepInputs.length; input++) {
      // If a field is empty...
      if (currentStepInputs[input].value == "") {
        console.log(`input ${currentStepInputs[input].name} is empty`);
        // add an "invalid" class to the field:
        this.inputError(currentStepInputs[input], "This field is required");
        // and set the current valid status to false
        valid = false;
      }
      // Only validate email format if field is not empty
      else if (currentStepInputs[input].name === "email") {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(currentStepInputs[input].value)) {
          this.inputError(currentStepInputs[input], "Invalid email address");
          valid = false;
        }
      }
    }
    // If the valid status is true, mark the step as finished and valid:
    if (valid) {
      document.getElementsByClassName("stepIndicator")[this.currentTab].className += " finish";
    }
    return valid; // return the valid status
  }

  private updateStepIndicator(tabNumber: number) {
    // This function removes the "active" class of all steps...
    var i,
      x = document.getElementsByClassName("stepIndicator");
    for (i = 0; i < x.length; i++) {
      x[i].className = x[i].className.replace(" active", "");
    }
    //... and adds the "active" class on the current step:
    x[tabNumber].className += " active";
  }

  private populateForm() {
    // Load saved form data from localStorage, or use existing this.fields
    const savedData = localStorage.getItem("registerFormData");
    if (savedData) {
      this.fields = JSON.parse(savedData);
    } else if (!this.fields) {
      // Initialize this.fields if it doesn't exist
      this.fields = {};
    }

    const formElements = document.querySelectorAll(".registerInput");
    formElements.forEach((element) => {
      const inputField = element.getAttribute("data-inputField")!;
      const { id, type, placeholder, name, autocomplete } = FIELDS[inputField];
      const innerElement = document.createElement("input");
      innerElement.id = `register-inputField-${id}`;
      innerElement.type = type;
      innerElement.placeholder = placeholder;
      innerElement.name = name;
      if (autocomplete) {
        innerElement.autocomplete = autocomplete;
      }
      innerElement.classList.value = "w-full px-4 py-3 rounded-md text-gray-700 font-medium border-solid border-2 border-gray-200";
      // Restore value using the input name (not inputField) to match storeTabFormData
      if (this.fields && this.fields[name]) {
        innerElement.setAttribute("value", this.fields[name]);
      }
      element.innerHTML = innerElement.outerHTML;

      // Add real-time password validation for password field
      if (name === "password") {
        const passwordInput = document.getElementById(`register-inputField-${id}`) as HTMLInputElement;
        if (passwordInput) {
          // Validate initial value if exists
          if (passwordInput.value) {
            this.validatePasswordRequirements(passwordInput.value);
          }
          // Add input event listener for real-time validation
          passwordInput.addEventListener("input", (event) => {
            const target = event.target as HTMLInputElement;
            this.validatePasswordRequirements(target.value);
          });
        }
      }
    });
  }

  private validatePasswordRequirements(password: string): void {
    // Check each requirement
    const hasLength = password.length >= 10;
    const hasNumber = /\d/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);

    // Update UI for each requirement
    this.updateRequirementStatus("password-requirement-length", hasLength);
    this.updateRequirementStatus("password-requirement-number", hasNumber);
    this.updateRequirementStatus("password-requirement-uppercase", hasUppercase);
    this.updateRequirementStatus("password-requirement-lowercase", hasLowercase);
  }

  private updateRequirementStatus(requirementId: string, isMet: boolean): void {
    const requirementElement = document.getElementById(requirementId);
    if (requirementElement) {
      const icon = requirementElement.querySelector(".requirement-icon") as HTMLElement;
      if (icon) {
        if (isMet) {
          icon.classList.remove("text-gray-400");
          icon.classList.add("text-green-500", "font-bold");
        } else {
          icon.classList.remove("text-green-500", "font-bold");
          icon.classList.add("text-gray-400");
        }
      }
    }
  }

  private storeTabFormData() {
    const currentStepInputs = this.steps[this.currentTab].getElementsByTagName("input");
    for (let input = 0; input < currentStepInputs.length; input++) {
      this.fields[currentStepInputs[input].name] = currentStepInputs[input].value;
      saveJsonToLocalStorage("registerFormData", this.fields);
    }
  }

  private submitForm(event: SubmitEvent) {
    event.preventDefault();

    this.registerForm.classList.add("hidden");
    document.querySelector<HTMLDivElement>("#app")!.innerHTML += pageLoadingTemplate;
    const formData = new FormData(this.registerForm);
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;
    const firstName = formData.get("firstName") as string;
    const lastName = formData.get("lastName") as string;

    cognitoSignUp(email, password, firstName, lastName)
      .then(() => {
        window.location.href = "/login?registered=success";
      })
      .catch((error) => {
        console.error("Error during registration:", error);
        // Redirect to login page with error message
        window.location.href = "/login?registered=error";
      });
  }

  private regeneratePrevNextButtons() {
    const formFooter = document.getElementById("form-footer");
    formFooter!.innerHTML = "";
    const prevButton = document.createElement("button");
    prevButton.type = "button";
    prevButton.id = "prevBtn";
    prevButton.innerHTML = "Previous";
    prevButton.classList.value = "flex-1 focus:outline-none border border-gray-300 py-2 px-5 rounded-lg shadow-sm text-center text-gray-700 bg-white hover:bg-gray-100 text-lg fade-in-image";
    prevButton.style.display = "inline";
    const nextButton = document.createElement("button");
    nextButton.type = "button";
    nextButton.id = "nextBtn";
    nextButton.innerHTML = "Next";
    nextButton.classList.value = "flex-1 border border-transparent focus:outline-none p-3 rounded-md text-center text-white bg-indigo-600 hover:bg-indigo-700 text-lg fade-in-image";
    const submitButton = document.createElement("button");
    submitButton.type = "submit";
    submitButton.id = "submitBtn";
    submitButton.innerHTML = "Submit";
    submitButton.classList.value = "flex-1 border border-transparent focus:outline-none p-3 rounded-md text-center text-white bg-indigo-600 hover:bg-indigo-700 text-lg fade-in-image";
    submitButton.style.display = "inline";
    submitButton.onsubmit = (event) => {
      event.preventDefault();
    }
    submitButton.onclick = (event) => {
      event.preventDefault();
      // Validate current tab before submitting
      if (this.validateForm()) {
        this.registerForm.requestSubmit();
      }
    };
    if (this.currentTab != 0) {
      formFooter?.appendChild(prevButton);
    }
    if (this.currentTab == this.steps.length - 1) {
      formFooter?.appendChild(submitButton);
    } else {
      formFooter?.appendChild(nextButton);
    }

    nextButton.addEventListener("click", () => {
      this.nextPrev(1);
    });

    prevButton.addEventListener("click", () => {
      this.nextPrev(-1);
    });
  }
}
